import { PartyPopper } from "lucide-react";
import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import { SunProtectionHeader } from "@/components/organisms/SunProtectionHeader/SunProtectionHeader";
import { isDebugMode } from "@/lib/debug";

export function OrderPlacedPage() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get("sunProtectionOrderId");
    const dealId = searchParams.get("dealId");
    const showDebugLink = isDebugMode() && Boolean(orderId) && Boolean(dealId);
    const signaturePageHref =
        orderId && dealId
            ? `/zonwering/bestelling-bevestigen?${new URLSearchParams({ sunProtectionOrderId: orderId, dealId }).toString()}`
            : "";

    return (
        <div className="min-h-screen bg-gray-50">
            <SunProtectionHeader />
            <main className="mx-auto max-w-lg px-4 py-12">
                <div className="rounded-2xl bg-white px-10 py-12 text-center shadow-sm">
                    <div className="mx-auto mb-6 flex size-16 items-center justify-center rounded-full bg-primary/15">
                        <PartyPopper className="size-8 text-primary" />
                    </div>
                    <h1
                        data-testid="order-placed-heading"
                        className="mb-3 text-2xl font-bold text-gray-900"
                    >
                        {t("orderPlacedPage.title")}
                    </h1>
                    <p className="mx-auto max-w-xs text-sm text-gray-500">
                        {t("orderPlacedPage.subtitle")}
                    </p>
                    {showDebugLink && (
                        <div className="mt-6 flex flex-col items-center gap-1 text-xs">
                            <a
                                data-testid="debug-signature-link"
                                href={signaturePageHref}
                                className="text-blue-600 underline hover:text-blue-800"
                            >
                                {t("orderPlacedPage.debug.signaturePageLink")}
                            </a>
                            <span className="text-gray-400">
                                {t("orderPlacedPage.debug.signaturePageHint")}
                            </span>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}
